module.exports = __webpack_public_path__ + "static/media/informa.8e30192f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/informa.png
 ** module id = 451
 ** module chunks = 0
 **/